export function getButtonSizeForInput(size) {
    switch (size) {
        case 'xl': {
            return 'l';
        }
        case 'l': {
            return 'm';
        }
        case 's': {
            return 'xs';
        }
        default: {
            return 's';
        }
    }
}
